<template>
  <ol class="breadcrumb bg-transparent m-0 p-0">
    <li v-for="(crumb, crumbLink) in crumbs" :key="crumb" class="breadcrumb-item">
      <i v-if="crumb.toLowerCase() == 'dashboard'" class="fas fa-home text-primary mr-1"></i>
      <inertia-link :href="route(crumbLink)">{{crumb}}</inertia-link>
    </li>
    <li v-if="activeItem" class="breadcrumb-item active">
      <i v-if="activeItem && !crumbs" class="fas fa-home text-primary mr-1"></i>
      {{activeItem}}
    </li>
  </ol>
</template>

<script>
  export default {
    props: {
      activeItem: String,
      crumbs: Object
    }
  }
</script>
